"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'MessageTemplate',
    props: {
        value: {
            type: String
        },
        placeholder: {
            type: String
        },
        options: {
            type: Object
        }
    },
    data() {
        return {
            show: false
        };
    },
    methods: {
        getLabel(value) {
            for (let i = 0; i < this.options.length; i++) {
                const item = this.options[i];
                // eslint-disable-next-line eqeqeq
                if (item.value == value) {
                    return item.label;
                }
            }
        },
        onSelect(val) {
            this.$emit('select', val.value, val);
            this.show = false;
        }
    }
});
